// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"46a39985","239":"e39fb35b","455":"8f6f83be","578":"d08f295d","970":"d5bb65a9","977":"ee845cd7"}[chunkId] + ".chunk.js";
};